module.exports = __webpack_public_path__ + "static/media/p_21_4.10b809e3.png";